module.exports = __webpack_public_path__ + "static/media/survey.fbb972f3.png";